var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIconSet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "30px",
    viewBox: "0 0 26 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "96450DDC-373D-401A-9948-A3DF2B9C41DD@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.525490 0 0 0 0 0.058824 0 0 0 0 0.619608 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ready",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets/Downloads",
    transform: "translate(-1256.000000, -533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other",
    transform: "translate(420.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    transform: "translate(738.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Img",
    transform: "translate(72.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other/Icons/24/download",
    transform: "translate(18.000000, 18.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.25,17.5 L26.25,17.5 L26.25,7 L15.75,7 L15.75,17.5 L8.75,17.5 L21,29.75 L33.25,17.5 Z M8.75,33.25 L8.75,36.75 L33.25,36.75 L33.25,33.25 L8.75,33.25 Z",
    id: "icon",
    fill: "#45FF00"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconSet);
export default __webpack_public_path__ + "04abd568221f9ef56bbe9c5c7de2df3f.svg";
export { ForwardRef as ReactComponent };